// widget-client/src/integrations/shoper.ts

/**
 * Integracja z platformą Shoper.
 * Automatycznie identyfikuje zalogowanych klientów.
 */

export interface ShoperCustomer {
  id: number;
  email: string;
  firstname: string;
  lastname: string;
}

export interface ShoperGlobal {
  customer?: ShoperCustomer;
  shop_id?: number;
}

declare global {
  interface Window {
    Shop?: ShoperGlobal;
  }
}

/**
 * Sprawdza czy strona jest sklepem Shoper
 */
export function isShoperStore(): boolean {
  return typeof window.Shop !== 'undefined';
}

/**
 * Pobiera dane zalogowanego klienta Shoper
 */
export function getShoperCustomer(): {
  customerId?: string;
  customerEmail?: string;
  customerName?: string;
} | null {
  if (!isShoperStore()) {
    return null;
  }

  const customer = window.Shop?.customer;

  if (!customer || !customer.email) {
    return null;
  }

  return {
    customerId: `shoper-${customer.id}`,
    customerEmail: customer.email,
    customerName: [customer.firstname, customer.lastname].filter(Boolean).join(' ') || undefined,
  };
}

/**
 * Automatycznie wzbogaca konfigurację widgetu o dane klienta Shoper
 */
export function enrichConfigWithShoperData(config: Record<string, any>): Record<string, any> {
  // Sprawdź czy auto-identify jest włączone
  if (config.autoIdentify === 'false' || config.autoIdentify === false) {
    return config;
  }

  const shoperCustomer = getShoperCustomer();

  if (!shoperCustomer) {
    return config;
  }

  // Nadpisz tylko jeśli nie podano explicite
  return {
    ...config,
    customerId: config.customerId || shoperCustomer.customerId,
    customerEmail: config.customerEmail || shoperCustomer.customerEmail,
    customerName: config.customerName || shoperCustomer.customerName,
  };
}
